import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { internationalZipPickerMethods } from 'site-modules/shared/components/international-zip-picker-methods/international-zip-picker-methods';
import { VehicleEntities } from 'client/data/models/vehicle';
import { CorePageParams } from 'site-modules/shared/utils/core-page/params';
import { VehiclePrice } from 'site-modules/shared/components/core-page/vehicle-price/vehicle-price';
import { UsedVehiclePrice } from 'site-modules/shared/components/core-page/used-vehicle-price/used-vehicle-price';
import { InternationalZipCodeForm } from './international-zip-picker';

import './international-zip-picker.scss';

const ZIP_PICKER_CREATIVE_ID = 'international-zip-cta';

export function InternationalZipPickerCtaUI({
  params,
  showActiveSpinner,
  onZipChangeInProgress,
  onBtnClick,
  vehicle,
  btnTitle,
}) {
  return (
    <div
      data-tracking-parent={ZIP_PICKER_CREATIVE_ID}
      className="d-flex flex-column justify-content-center international-we-cant-find-you rounded my-1_5 my-md-0 p-1"
    >
      {!!vehicle && (
        <Fragment>
          {params.isUsed ? (
            <UsedVehiclePrice params={params} submodelSlug={get(vehicle, 'submodels.slug')} />
          ) : (
            <VehiclePrice vehicle={vehicle} />
          )}
          <hr className="w-100 my-1" />
        </Fragment>
      )}
      <div className="heading-5 pb-0_25">Oops, we can’t seem to locate you</div>
      <div className="mb-0_5">Please enter a U.S. ZIP code to see vehicles for sale.</div>
      <InternationalZipCodeForm
        colConfig={{
          zip: { xs: 5, md: 12, xl: 5, className: 'pe-lg-0 mb-md-0_5 mb-xl-0' },
          btn: { xs: 7, md: 12, xl: 7 },
        }}
        onZipChangeInProgress={onZipChangeInProgress}
        onBtnClick={onBtnClick}
        showActiveSpinner={showActiveSpinner}
        placeholder="ZIP Code"
        btnClasses="btn-primary-darker medium"
        btnTitle={btnTitle}
        trackingId="provide_zip_code"
        trackingValue={btnTitle}
      />
    </div>
  );
}

InternationalZipPickerCtaUI.propTypes = {
  params: CorePageParams.isRequired,
  showActiveSpinner: PropTypes.bool,
  onZipChangeInProgress: PropTypes.func.isRequired,
  onBtnClick: PropTypes.func.isRequired,
  vehicle: PropTypes.oneOfType([VehicleEntities.MakeModelSubmodelYear, PropTypes.bool]),
  btnTitle: PropTypes.string,
};

InternationalZipPickerCtaUI.defaultProps = {
  showActiveSpinner: false,
  vehicle: false,
  btnTitle: 'See Pricing',
};

export const InternationalZipPickerCta = internationalZipPickerMethods(InternationalZipPickerCtaUI);
